module.exports = __webpack_public_path__ + "img/Perfil.a987a1af.png";